/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ billed: NonNullable<unknown> }} Partner_Customer_Kpi_BilledInputs */



/**
* | output |
* | --- |
* | "{billed} billed seats" |
*
* @param {Partner_Customer_Kpi_BilledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_kpi_billed = /** @type {((inputs: Partner_Customer_Kpi_BilledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Kpi_BilledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.billed} abgerechnete Plätze`)
	return /** @type {LocalizedString} */ (`${i?.billed} billed seats`)
});